import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../services/supabaseClient';

const PengurusAdmin = () => {
    const { userRole } = useAuth();
    const isAdminNasional = userRole === 'admin_nasional';

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [form, setForm] = useState({ name: '', position: '' });

    const fetchData = async () => {
        try {
            setIsLoading(true);
            const { data: result, error } = await supabase
                .from('pengurus')
                .select('*')
                .order('created_at', { ascending: false });

            if (error) throw error;
            setData(result || []);
        } catch (error) {
            console.error('Error fetching pengurus:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isAdminNasional) return;

        try {
            setIsSubmitting(true);
            const { error } = await supabase
                .from('pengurus')
                .insert([{ name: form.name, position: form.position }]);

            if (error) throw error;

            setForm({ name: '', position: '' });
            fetchData();
        } catch (error) {
            console.error('Error inserting pengurus:', error);
            alert('Gagal menambah data pengurus.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDelete = async (id) => {
        if (!isAdminNasional || !window.confirm('Yakin ingin menghapus data ini?')) return;

        try {
            const { error } = await supabase
                .from('pengurus')
                .delete()
                .eq('id', id);

            if (error) throw error;
            setData((prev) => prev.filter((item) => item.id !== id));
        } catch (error) {
            console.error('Error deleting pengurus:', error);
            alert('Gagal menghapus data pengurus.');
        }
    };

    return (
        <div className="p-6 max-w-5xl mx-auto">
            <h1 className="text-2xl font-bold text-gray-800 mb-2">Manajemen Pengurus</h1>
            <p className="text-gray-600 mb-6">Kelola struktur kepengurusan HEBITREN.</p>

            <div className="flex flex-col md:flex-row gap-6">
                {/* Form Tambah - Hanya dirender untuk Admin Nasional */}
                {isAdminNasional && (
                    <div className="w-full md:w-1/3 bg-white p-6 rounded-lg shadow-sm border border-gray-200 h-fit">
                        <h2 className="text-lg font-semibold mb-4 text-gray-700">Tambah Pengurus</h2>
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Nama Lengkap</label>
                                <input
                                    type="text"
                                    required
                                    value={form.name}
                                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                                    placeholder="Contoh: KH. Ahmad Dahlan"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Jabatan</label>
                                <input
                                    type="text"
                                    required
                                    value={form.position}
                                    onChange={(e) => setForm({ ...form, position: e.target.value })}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                                    placeholder="Contoh: Ketua Umum"
                                />
                            </div>
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="w-full bg-blue-600 text-white font-medium py-2 px-4 rounded-md hover:bg-blue-700 disabled:opacity-70 transition-colors"
                            >
                                {isSubmitting ? 'Menyimpan...' : 'Simpan'}
                            </button>
                        </form>
                    </div>
                )}

                {/* Tabel Data (Read-Only untuk Admin Provinsi) */}
                <div className={`w-full ${isAdminNasional ? 'md:w-2/3' : 'md:w-full'} bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden`}>
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nama</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Jabatan</th>
                                    {isAdminNasional && <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Aksi</th>}
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {isLoading ? (
                                    <tr><td colSpan={isAdminNasional ? 3 : 2} className="px-6 py-8 text-center text-gray-500">Memuat data...</td></tr>
                                ) : data.length === 0 ? (
                                    <tr><td colSpan={isAdminNasional ? 3 : 2} className="px-6 py-8 text-center text-gray-500">Belum ada data pengurus.</td></tr>
                                ) : (
                                    data.map((item) => (
                                        <tr key={item.id} className="hover:bg-gray-50">
                                            <td className="px-6 py-4 text-sm font-medium text-gray-900">{item.name}</td>
                                            <td className="px-6 py-4 text-sm text-gray-500">{item.position}</td>
                                            {isAdminNasional && (
                                                <td className="px-6 py-4 text-sm font-medium text-center">
                                                    <button
                                                        onClick={() => handleDelete(item.id)}
                                                        className="text-red-600 hover:text-red-900 transition-colors"
                                                    >
                                                        Hapus
                                                    </button>
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PengurusAdmin;